import React from 'react'

class MilestoneSummary extends React.Component {
  hasEvents(){
    return this.countEvents() > 0
  }

  hasOneEvent() {
    return this.countEvents() == 1
  }

  countEvents() {
    return this.props.milestone_events.length
  }

  firstMilestoneName() {
    return this.props.milestone_events[0].name
  }

  allMilestoneNames() {
    let names = this.props.milestone_events.map((e, i) =>{
      return e.name
    })
    return names.join(', ')
  }

  renderMileStonePresentContent() {
    if(this.hasOneEvent()){
      return(
        <div className='milestone-summary present'>
          {this.firstMilestoneName()}
        </div>
      )
    } else{
      return(
        <div className='milestone-summary present'>
          Milestone {this.countEvents()}
          <div className='milestone-names'>
            {this.allMilestoneNames()}
          </div>
        </div>
      );
    }
  }

  render(){
    return(
      <div>
      { this.hasEvents() ? (this.renderMileStonePresentContent()) : (<div className='milestone-summary'/>) }
      </div>
    );
  }
}

export default MilestoneSummary 
